<template>
  <div id="app">
    <notifications></notifications>
    <idleModal></idleModal>
    <router-view></router-view>
  </div>
</template>

<script>
import notifications from "./components/helper/notifications";
import idleModal from "./components/helper/idleModal";
import { mapState, mapMutations } from "vuex";

export default {
  name: "App",
  components: {
    notifications,
    idleModal,
  },
  computed: {
    ...mapState({
      authenticated: (state) => state.auth.authenticated,
      user: (state) => state.auth.user,
    }),
  },
  data() {
    return {};
  },
  methods: {
    ...mapMutations({
      setAuthenticated: "auth/SET_AUTHENTICATED",
    }),
  },
  created() {
    /* if(this.$store.state.auth.authenticated){
      this.$store.dispatch('get','api/v1/eventtypes')
      .then((data)=>{
          console.log(data);
          this.$store.state.eventtypes = data.data.data;
      });

      this.$store.dispatch('get','api/v1/committees/all')
      .then((data)=>{
          console.log(data);
          this.$store.state.committees = data.data.data;
      });
    } */
  },
  onIdle() {
    if (this.$route.meta.AuthRequired) {
      localStorage.removeItem("token");
      this.setAuthenticated(false);
      window.$("#inActiveModal").modal("show");
    }
  },
};
</script>

<style>
a {
  color: #000;
}
a:hover {
  color: #fff;
}
button label {
  margin-bottom: 0px;
}

.select2-container--default
  .select2-selection--single
  .select2-selection__arrow,
.select2-container--default
  .select2-selection--single
  .select2-selection__placeholder {
  height: 38px !important;
}
.select2-container--default
  .select2-selection--single
  .select2-selection__rendered {
  line-height: 38px !important;
}
.select2-container {
  display: block !important;
  width: 100% !important;
  /* min-width: 200px !important; */
}
.modal-body {
  max-height: 80vh;
  overflow-y: auto;
}

.btn-primary.bg-dark {
  border-color: #000;
}
.mem-titl-wrap {
  width: 65% !important;
  margin: auto;
}
.mem-admin-wrap {
  min-height: 500px !important;
  height: -webkit-fit-content !important;
  height: -moz-fit-content !important;
  height: fit-content !important;
}
.com-attent-wrap {
  overflow-x: scroll;
}
.com-attent-wrap::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  background-color: #ccc;
}
.com-attent-wrap::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  background-color: #ccc;
}
.com-attent-wrap::-webkit-scrollbar-thumb {
  background-color: #4192d9;
}

.table-responsive::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  background-color: #ccc;
}
.table-responsive::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  background-color: #ccc;
}
.table-responsive::-webkit-scrollbar-thumb {
  background-color: #4192d9;
}

.list-group .list-group-item:hover {
  color: white !important ;
}
.list-group .dropdown:hover {
  color: white !important;
}
.content-title-wrap {
  display: flex;
  justify-content: space-between;
}
.content-btn-wrap {
  border: 1px solid #ced4da;
  display: flex;
  display: flex;
  align-items: center;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  background: white;
  margin-bottom: 7px;
  transition: 0.4s ease;
}
.content-btn-wrap:hover {
  background: #d3d3d357;
}
.content-btn-wrap i {
  font-size: 13px;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  margin: auto;
}
.help-cont-wrap {
}
.help-inner-wrap {
  border: 1px solid #ced4da;
  padding: 10px;
  border-radius: 5px;
}
.help-inp-wrap {
  margin-bottom: 15px;
}
.help-content-btn {
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  margin-left: auto;
  margin-bottom: 5px;
  margin-top: 16px;
}
.help-content-btn .btn {
  width: 95px;
}
.help-content-btn .btn i {
  margin-right: 6px;
}
.no-border {
  border: none !important;
}
.no-border .btn i {
  font-size: 15px !important;
}
.help-core {
  display: block;
}
.content-image-wrap {
}
.content-image-ul {
  padding-left: 0;
  margin-top: 10px;
}
.content-image-li {
  display: inline-flex;
  border: 1px solid lightgray;
  list-style: none;
  margin-bottom: 10px;
  padding: 2px 10px;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  border-radius: 15px;
  align-items: center;
  margin-right: 8px;
}
.content-image-li i {
  color: darkred;
  margin-left: 15px;
  font-size: 13px;
}
.help-content-cont2 {
  background: white;
  border: 1px solid #a9a9a93b;
  border-radius: 10px;
  padding: 20px;
  /* margin-bottom: 15px; */
  margin-top: 15px;
}
.cont-h6 {
  font-size: 16px;
  font-weight: 800;
  text-transform: uppercase;
  color: black;
  margin-bottom: 16px;
}
.cont2-p {
  margin-bottom: 7px;
  font-size: 16px;
  line-height: 19px;
}
.cont-txt-p {
  background: #d3d3d31f;
  border-radius: 10px;
  padding: 16px 21px;
  color: black;
  font-size: 16px;
  margin-top: 12px;
}
.content-img-ul2 {
  margin-top: 0px !important;
  margin-bottom: 7px;
}
.content-arr-cont {
  justify-content: space-between;
}
.content-arr-wrap {
  display: flex;
}
@media (max-width: 1200px) {
  .grid {
    grid-gap: 35px 20px;
  }
  .grid {
    display: block !important;
    grid-gap: 35px 20px;
  }
  .home-crd {
    margin-bottom: 20px;
  }
  .list-h3 {
    font-size: 24px;
  }
  .list-btn {
    font-size: 15px !important;
  }
}
@media (max-width: 990px) {
  .grid {
    display: block !important;
    grid-gap: 35px 20px;
  }

  .home-container {
    padding-left: 0;
    padding-right: 0;
  }
  .pro-img {
    width: 130px !important;
  }
  .mem-btn-wrap {
    padding: 20px 44px !important;
  }
  .nav-cont-wrap {
    align-items: unset !important;
  }
  .navbar-brand {
    padding-top: 10px;
  }
  .brdcrm-wrap {
    margin-top: 65px;
  }
}
@media (max-width: 768px) {
  .mem-srch-wrap {
    float: unset !important;
  }
  .search-box {
    width: 100% !important;
  }
  .mem-plus-a {
    float: right;
  }
  .plr-0 {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .c-pro-wrap {
    padding: 25px 16px !important;
  }
  .mem-btn-wrap {
    padding: 20px 0px !important;
  }
  .brdcrm-wrap {
    margin-top: 0px;
  }
  .brdcrm-ul {
    padding-top: 15px;
  }
  .pright-g {
    padding-left: 10px !important;
    padding-right: 16px !important;
  }
  .innside-wrap {
    width: 210px;
    position: absolute;
    z-index: 999;
    background: #4090d6 !important;
    top: -2px;
    left: 0px;
  }
  .innside-tog-wrap {
    position: relative;
    top: -51px;
    left: -2px;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
  }
  .innside-tog {
    width: 28px;
    height: 4px;
    background: black;
    display: block;
    margin-bottom: 5px;
    transition: 0.5s ease;
  }
}
@media (max-width: 650px) {
  .mem-btn-wrap {
    padding: 20px 44px !important;
  }
  .main-content-wrap {
    padding: 0px 0px !important;
  }
  .layout-container {
    margin-top: 0 !important;
  }

  .list-btn {
    font-size: 15px !important;
    margin-right: 0px !important;
  }
  .itmg-src-wrap {
    display: block !important;
  }
  .itmg-inp-wrap {
    padding-left: 0 !important;
  }
  .innside-tog-wrap {
    top: -36px;
  }
  .email-add-row {
    margin-top: 10px;
  }
  .evnt-tBtn {
    margin-top: 10px;
    margin-left: 10px;
  }
  .committee-wrp {
    padding: 15px;
  }
}
@media (max-width: 500px) {
  .mem-titl-wrap {
    width: 100% !important;
  }
  .mem-outer-wrap {
    padding: 20px 12px !important;
  }
  .layout-container {
    margin-top: 0 !important;
  }
  .main-content-wrap {
    padding: 0px 0px !important;
  }
  .mem-btn-wrap {
    padding: 20px 25px !important;
  }
  .dash-pdd {
    padding: 15px !important;
  }
  .dash-npd {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
  .mail-in-wrap {
    padding: 0 13px;
  }
  .email-add-row {
    align-items: center;
    padding: 10px 10px 0px;
    justify-content: space-between;
  }
  .email-ad-h3 {
    font-size: 21px;
  }
  .email-ad-a {
    font-size: 15px !important;
  }
  .itmg-tit-wrap {
    display: block !important;
  }
  .evnt-tb-wrap {
    min-width: 450px;
  }
  .evnt-div-wrap {
    overflow-x: scroll;
  }
}
v @media (max-width: 420px) {
  .email-add-row {
    margin-top: 0;
    display: block;
  }
  .adr-btnWrap {
    width: 100% !important;
  }
  .email-ad-a {
    float: none !important;
    margin-bottom: 19px !important;
    margin-left: 16px;
    margin-top: 10px;
  }
}
list-group .list-group-item:hover {
  color: white !important ;
}
.list-group .dropdown:hover {
  color: white !important;
}
.content-title-wrap {
  display: flex;
  justify-content: space-between;
}
.content-btn-wrap {
  border: 1px solid #ced4da;
  display: flex;
  display: flex;
  align-items: center;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  background: white;
  margin-bottom: 7px;
  transition: 0.4s ease;
}
.content-btn-wrap:hover {
  background: #d3d3d357;
}
.content-btn-wrap i {
  font-size: 13px;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  margin: auto;
}
.help-cont-wrap {
}
.help-inner-wrap {
  border: 1px solid #ced4da;
  padding: 10px;
  border-radius: 5px;
}
.help-inp-wrap {
  margin-bottom: 15px;
}
.help-content-btn {
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  margin-left: auto;
  margin-bottom: 5px;
  margin-top: 16px;
}
.help-content-btn .btn {
  width: 95px;
}
.help-content-btn .btn i {
  margin-right: 6px;
}
.no-border {
  border: none !important;
}
.no-border .btn i {
  font-size: 15px !important;
}
.help-core {
  display: block;
}

.content-image-ul {
  padding-left: 0;
  margin-top: 10px;
}
.content-image-li {
  display: inline-flex;
  border: 1px solid lightgray;
  list-style: none;
  margin-bottom: 10px;
  padding: 2px 10px;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  border-radius: 15px;
  align-items: center;
  margin-right: 8px;
}
.content-image-li i {
  color: darkred;
  margin-left: 15px;
  font-size: 13px;
}
.help-content-cont2 {
  background: white;
  border: 1px solid #a9a9a93b;
  border-radius: 10px;
  padding: 20px;
  /* margin-bottom: 15px; */
  margin-top: 15px;
}
.cont-h6 {
  font-size: 16px;
  font-weight: 800;
  text-transform: uppercase;
  color: black;
  margin-bottom: 16px;
}
.cont2-p {
  margin-bottom: 7px;
  font-size: 16px;
  line-height: 19px;
}
.cont-txt-p {
  background: #d3d3d31f;
  border-radius: 10px;
  padding: 16px 21px;
  color: black;
  font-size: 16px;
  margin-top: 12px;
}
.content-img-ul2 {
  margin-top: 0px !important;
  margin-bottom: 7px;
}
.content-arr-cont {
  justify-content: space-between;
}
.content-arr-wrap {
  display: flex;
}

:root {
  --ms-tag-bg: rgba(65, 146, 218, 0.25);
  --ms-tag-color: black;
  --ms-tag-font-weight: 400;
  --ms-tag-font-size: 1rem;
  --ms-tag-py: 0.5rem;
}

.multiselect {
  align-items: baseline !important;
}

.multiselect-option.is-selected {
  background: var(--ms-option-bg-selected, #4192d9) !important;
  color: var(--ms-option-color-selected, #fff);
}

/* lato-regular - latin */
@font-face {
  font-family: "Lato";
  font-style: normal;
  font-weight: 400;
  src: url("/assets/fonts/lato-v17-latin-regular.eot"); /* IE9 Compat Modes */
  src: local(""),
    url("/assets/fonts/lato-v17-latin-regular.eot?#iefix")
      format("embedded-opentype"),
    /* IE6-IE8 */ url("/assets/fonts/lato-v17-latin-regular.woff2")
      format("woff2"),
    /* Super Modern Browsers */ url("/assets/fonts/lato-v17-latin-regular.woff")
      format("woff"),
    /* Modern Browsers */ url("/assets/fonts/lato-v17-latin-regular.ttf")
      format("truetype"),
    /* Safari, Android, iOS */
      url("/assets/fonts/lato-v17-latin-regular.svg#Lato") format("svg"); /* Legacy iOS */
}
html body {
  font-family: Lato !important;
}
/* common styling used in this website */
.bg-primary {
  background: #4192d9 0% 0% no-repeat padding-box !important;
}

.bg-dark {
  background: #292929 0% 0% no-repeat padding-box !important;
}
.list-group-item {
  border: unset !important;
  background-color: unset;
  color: #292929 !important;
  opacity: 1 !important;
  padding: 0.2rem 1rem !important;
  margin: 0.5rem 0.35rem;
}
.list-group-item a {
  color: #292929 !important;
  text-decoration: unset;
}

.list-group {
  list-style: none;
  background-color: rgba(65, 146, 218, 0.25) !important;
}

.list-group-item:hover,
.active-item {
  background: #4192d9;
  box-shadow: 0px 3px 6px #00000029;
  opacity: 1;
  color: #ffffff !important;
}
.list-group-item:hover:after,
.active-item:after {
  display: inline-block;
  font-family: "Font Awesome 5 Free";
  content: "\f0da";
  font-weight: 900;

  float: right;
}
.list-group-item:hover,
.active-item a {
  color: #ffffff !important;
  text-decoration: unset;
}
.container-bg {
  background-color: rgba(65, 146, 218, 0.25) !important;
}
.btn-dark {
  background: #292929 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #00000029 !important;
  border-radius: 4px !important;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  font-size: 18px !important;
}
.btn.btn-danger {
  color: #fff;
}

.btn-primary:not(:disabled):not(.disabled).active:focus,
.btn-primary:not(:disabled):not(.disabled):active:focus,
.show > .btn-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgb(0 0 0 / 50%);
}

.btn.btn-primary {
  background-color: #000;
  border-color: #000;
}
.text-black {
  color: #000 !important;
}
#dropdownMenuButton:focus {
  box-shadow: none;
}
.dark-text:hover {
  color: #fff !important;
} 
.multiselect .multiselect-clear, .multiselect .multiselect-caret{
  margin-top: 10px;
}
</style>
